import { submitNativeApplication } from '@lotushealth/lotushealth_js_sdk/endpoints';
import type { SubmitNativeApplicationRequestT } from '@lotushealth/lotushealth_js_sdk/schemas';
import type { SubmitNativeApplication200 } from '@lotushealth/lotushealth_js_sdk/schemas';

import { createLotusRequestConfig } from '@/shared/api/lotus';

export async function submitNativeApplicationApi(
  data: SubmitNativeApplicationRequestT,
  signal?: AbortSignal
): Promise<SubmitNativeApplication200> {
  const config = await createLotusRequestConfig({ signal });
  const response = await submitNativeApplication(data, config);
  return response.data;
}
